import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard'
import { EventSubscriber } from 'apprise-frontend-events/subscriptions'
import { useTagModules } from 'apprise-frontend-tags/tag/modules'
import { PropsWithChildren } from 'react'
import { useTenantChangeListener } from './events'
import { useTenantTaggeModule } from './plugins'

export type TenantInitialiserProps = PropsWithChildren

export const TenantInitialiser = (props: TenantInitialiserProps) => {

    const { children } = props

    const tagRegistry = useTagModules()
    const tagModule = useTenantTaggeModule()

    const changeListener = useTenantChangeListener()

    const activate = () => {

        tagRegistry.register(tagModule)

    }

    const { content } = useRenderGuard({

        render: <EventSubscriber name='tenant-change-listener' subscriptions={[changeListener]} >
            {children}
        </EventSubscriber>,
        orRun: activate
    })

    return content
}